import {
  setCurrentTabValue,
  setDefaultTabValue,
} from '../store-actions/settings-store-actions';
import { TabQueryParam } from '../types/settings-types';

export const setCurrentTabFromURL = (locationSearch: string) => {
  const urlParams = new URLSearchParams(locationSearch);
  const tabParam = urlParams.get('tab');
  const tab = tabParam as TabQueryParam;
  const isValidTab = Object.values(TabQueryParam).includes(tab);
  if (isValidTab) {
    setCurrentTabValue(tab);
  } else {
    setDefaultTabValue();
  }
};
